
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wing/[article]",
      function () {
        return require("private-next-pages/wing/[article].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wing/[article]"])
      });
    }
  